export default __webpack_public_path__ + "static/media/famoushookahmobile.d0f8a515.mp4";